export default "__VITE_ASSET__BPBFkPGQ__"